import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class SftpIntegrationService {
    private readonly base = '/admin/sftp';

    getTransfers(params: {
        page: number;
        size: number;
        status?: string;
        partnerCode?: string;
        schemaValid?: boolean;
        startDate?: string;
        transferDirection?: string;
    }) {
        return fetchWithRetry(API.get(`${this.base}/transfers`, { params }));
    }

    getTransfer(id: number) {
        return fetchWithRetry(API.get(`${this.base}/transfers/${id}`));
    }

    getHistory(id: number) {
        return fetchWithRetry(API.get(`${this.base}/transfers/${id}/history`));
    }

    saveStaging(id: number, body: Record<string, unknown>) {
        return fetchWithRetry(API.put(`${this.base}/transfers/${id}/staging`, body));
    }

    reprocessValidation(id: number) {
        return fetchWithRetry(API.post(`${this.base}/transfers/${id}/reprocess-validation`));
    }

    retryProcessing(id: number) {
        return fetchWithRetry(API.post(`${this.base}/transfers/${id}/retry-processing`));
    }

    approve(id: number, comment?: string) {
        return fetchWithRetry(API.post(`${this.base}/transfers/${id}/approve`, { comment }));
    }

    reject(id: number, reason?: string) {
        return fetchWithRetry(API.post(`${this.base}/transfers/${id}/reject`, { reason }));
    }

    download(id: number) {
        return fetchWithRetry(
            API.get(`${this.base}/transfers/${id}/download`, { responseType: 'blob' })
        );
    }

    poll(code: string) {
        return fetchWithRetry(API.post(`${this.base}/integrations/${code}/poll`));
    }

    listIntegrations() {
        return fetchWithRetry(API.get(`${this.base}/integrations`));
    }

    getIntegration(code: string) {
        return fetchWithRetry(API.get(`${this.base}/integrations/${code}`));
    }

    createIntegration(body: Record<string, unknown>) {
        return fetchWithRetry(API.post(`${this.base}/integrations`, body));
    }

    updateIntegration(code: string, body: Record<string, unknown>) {
        return fetchWithRetry(API.put(`${this.base}/integrations/${code}`, body));
    }

    testConnection(code: string) {
        return fetchWithRetry(API.post(`${this.base}/integrations/${code}/test-connection`));
    }

    saveCredentials(code: string, body: { password?: string; privateKeyPem?: string; knownHosts?: string }) {
        return fetchWithRetry(API.put(`${this.base}/integrations/${code}/credentials`, body));
    }

    deleteCredentials(code: string) {
        return fetchWithRetry(API.delete(`${this.base}/integrations/${code}/credentials`));
    }

    discoverHostKey(code: string) {
        return fetchWithRetry(API.post(`${this.base}/integrations/${code}/discover-host-key`));
    }

    sendTest(code: string) {
        return fetchWithRetry(API.post(`${this.base}/integrations/${code}/send-test`));
    }

    dispatch(body: { epcisId: number; partnerCode: string; schemaVersion?: string }) {
        return fetchWithRetry(API.post(`${this.base}/integrations/dispatch`, body));
    }

    provisionHostedAccount(code: string) {
        return fetchWithRetry(API.post(`${this.base}/integrations/${code}/hosted-account`));
    }

    listTemplates() {
        return fetchWithRetry(API.get(`${this.base}/integration-templates`));
    }
}

const sftpIntegrationService = new SftpIntegrationService();
export default sftpIntegrationService;
